import { FC } from 'react';

import { ACTION_LIST } from '..';
import { ActionItem, ActionListWrapper } from '../Wrapper';
import { useActionListHandlers } from '../hooks';
import { ActionListProps } from '../types';

const ActionList: FC<ActionListProps> = props => {
  const [handleOpenPicker, ...actionsHandlers] = useActionListHandlers(props);

  return (
    <ActionListWrapper>
      {ACTION_LIST.map((actionName, index) => (
        <ActionItem key={actionName} onClick={actionsHandlers[index]}>
          {actionName}
        </ActionItem>
      ))}
      <ActionItem onClick={handleOpenPicker}>Custom</ActionItem>
    </ActionListWrapper>
  );
};

export default ActionList;
